
	import { onMounted, ref } from 'vue';
	import moment, { Moment } from 'moment';
	import {GetBlogsForProduct} from 'Apis/apis';
	import Swiper, {Navigation} from 'swiper';
	Swiper.use([Navigation]);

	export default {
		name: 'BlogsMobile',
		setup() {
			const blogs = ref([]);
			const blogsLoading = ref(true);
			const fallbackImage = ref('/ResourcePackages/RoyalPrestige/assets/src/project/images/Misc/noimage.jpg');
			const translations = ref({});
			const mobileBlogs = ref(null);
			const prevButton = ref(null);
			const nextButton = ref(null);
			const currentCulture = document.body.getAttribute('data-current-culture');
			if (currentCulture == "pt") {
				moment.locale('pt-br'); // Ensures locale is set
			}
			else if (currentCulture == "en") {
				moment.locale('en');

			}
			else {
				moment.locale('es');
			}

			let productId = document.querySelector('.js-blogs').getAttribute('data-product-id') ? document.querySelector('.js-blogs').getAttribute('data-product-id') : "";

			let setupSwiper = () => {
				let mySwiper = new Swiper(mobileBlogs.value, {
					slidesPerView: 1,
					spaceBetween: 0,
					navigation: {
						nextEl: nextButton.value,
						prevEl: prevButton.value,
					}
				});
			};

			async function getBlogs(productId) {
				const rsp = await GetBlogsForProduct(productId);
				//preload images before assigning
				let modifiedArr = [];
				let promises = [];
				let thumbnailPromise;				

				for (let [index, item] of rsp.value.entries()) {
					if(item.Image.length) {
						thumbnailPromise = new Promise((resolve) => {
							let thumbnail = new Image();
							thumbnail.onload = resolve;
							thumbnail.src = item.Image[0]?.Url;							
							//item.pubFormattedDate = new Date(item.PublicationDate);
							if (currentCulture == "pt") {
								item.pubFormattedDate = moment(item.PublicationDate).format('ll');
							}
							else if (currentCulture == "en") {
								item.pubFormattedDate = moment(item.PublicationDate).format('MMM DD, YYYY');
							}
							else {
								item.pubFormattedDate = moment(item.PublicationDate).format('DD MMM , YYYY');
							}
							item.Title = item.Title.replace(/[®]/g, '<sup class="blog-reg">$&</sup>');
							item.Summary = item.Summary.replace(/[®]/g, '<sup class="blog-reg">$&</sup>');
						});
						promises.push(thumbnailPromise);
					}
					modifiedArr.push(item);
				}

				// Wait for both promises to be resolved
				if (thumbnailPromise) {
					await Promise.all(promises);
				}
				//END Preload

				blogs.value = modifiedArr; // rsp?.value;
				setupSwiper();
				blogsLoading.value = false;
			}
					
			onMounted(() => {
				const translationEl = document.querySelector('.js-blogs');
				const translationValue = translationEl.getAttribute('data-translations');
				if (translationEl && translationValue) {
					translations.value = JSON.parse(translationValue);
				}
				getBlogs(productId);
			});

			return {
				blogs,
				productId,
				blogsLoading,
				fallbackImage,
				translations,
				mobileBlogs,
				nextButton,
				prevButton
			};
		},
	};
